<template>
    <menu v-on:mouseleave="onMouseLeave">
        <media :query="{minWidth: 1200}" @media-enter="isMobile = false" @media-leave="isMobile = true" />
        <slot name="toggle" v-bind:toggle-events="toggleEvents" v-bind:is-open="isOpen" v-if="isMobile"></slot>
        <template v-if="!isMobile || isOpen">
            <slot></slot>
        </template>
    </menu>
</template>

<script>
import Media from 'vue-media';

export default {
    name: 'MainMenu',
    components: {
        Media
    },
    provide() {
        return {
            mainMenuSharedState: this.sharedState
        }
    },
    data() {
        let self = this;
        return {
            sharedState: {
                isMobile: true,
                activeMenuItem: null
            },
            toggleEvents: {
                click(e) {
                    e.preventDefault();
                    self.isOpen = !self.isOpen;
                }
            },
            isOpen: false
        }
    },
    computed: {
        isMobile: {
            get: function () {
                return this.sharedState.isMobile;
            },
            set: function (v) {
                this.sharedState.isMobile = v;
            }
        }
    },
    watch: {
        isMobile (newValue) {
            let self = this;
            if (!newValue) {
                self.isOpen = false;
                self.sharedState.activeMenuItem = '';
            }
        }
    },
    methods: {
        onMouseLeave() {
            if (!this.isMobile) {
                this.closeMenu();
            }
        },
        closeMenu() {
            this.sharedState.activeMenuItem = null;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/js/components/MainMenu.vue